import { Action, ActionType } from "@redux/actionTypes/tollingPlantCostActionType";
import { Reducer } from "redux";
import { Iheaders } from "./analyticalPBFReducer";

export interface IToolingPlantCostState {
  toolingPlantCostDetailsByPID: IToolingPlantCostDetailsByPID[];
}

export interface IToolingPlantCostDetailsByPID {
  projectId: number;
  projectName?: string;
  isDraft?: boolean;
  isApiDevelopment?: boolean;
  toolingMiscCapexDetail: {
    data: IToolingMiscCapexDetails[];
    total?: Record<string, any>;
  };
  plantCost: {
    manufacturingPlantId: number;
    perDayPlantCost: number;
    scaleUp: IPlantCostDetails;
    exhibits: IPlantCostDetails;
  };
}

export interface IToolingMiscCapexDetails {
  projectId?: number;
  toolingMiscCapexId?: number;
  toolingMiscCapexType: string;
  prototype: number;
  scaleUp: number;
  exhibit: number;
}

export interface IPlantCostDetails {
  headers?: Iheaders[];
  data: Record<string, any>[];
  total?: Record<string, any>;
}

const initialState = {
  toolingPlantCostDetailsByPID: [],
};

export const ToolingPlantCostReducer: Reducer<IToolingPlantCostState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.TOOLING_PLAN_COST_DETAILS_BY_PID:
      return {
        ...state,
        toolingPlantCostDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
